import { Plus } from "lucide-react";
import { Button } from "../../design-system";

/** One primary creation action per page, outside the header and content flow. */
export function ConsoleFab({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Button className="mcc-fab" onClick={onClick} aria-label={label}>
      <Plus size={22} aria-hidden="true" />
      <span>{label}</span>
    </Button>
  );
}
